import React, { useCallback, useEffect, useState } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getOcppTagsCards } from '../../hooks/ocpptags';
import { getTenants } from '../../hooks/tenants';
import { getUserGroups } from '../../hooks/users';
import UserCreateForm from '../organisms/UserForm/UserCreateForm';
import { getCompanies } from '../../hooks/company';
import { connect } from 'react-redux';

const UserCreatePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }
`;

const UserCreatePage = (chargePointsList) => {
  const [userGroups, setUserGroups] = useState({});
  const [tenants, setTenants] = useState({});
  const [ocppTagCards, setOcppTagCards] = useState(null);
  const [companiesList, setCompaniesList] = useState(null);

  const history = useHistory();
  const location = useLocation();

  const isVehicle = history.location.state?.isVehicle;

  const getCompaniesData = useCallback(async () => {
    const companiesData = await getCompanies();

    setCompaniesList(companiesData.companyList);
  }, []);

  useEffect(() => {
    (async () => {
      if (!Object.keys(userGroups).length) setUserGroups(await getUserGroups());
      if (!Object.keys(tenants).length) setTenants(await getTenants());
      setOcppTagCards(await getOcppTagsCards('CARD'));
    })();
  }, []);

  useEffect(() => {
    (async function () {
      await getCompaniesData();
    })();
  }, []);

  if (ocppTagCards === null || (isVehicle && companiesList === null))
    return (
      <UserCreatePageWrapper>
        <Skeleton active />
      </UserCreatePageWrapper>
    );

  function mapOcppTags(tags) {
    if (tags.length) {
      return tags
        .filter((ocppTag) => ocppTag.parentUserPk === null)
        .map((ocppTag) => {
          return {
            key: ocppTag.ocppTagPk,
            title: ocppTag.idTag,
          };
        });
    }
  }

  const availableOcppTagList = ocppTagCards.ocppTagList;

  const initialValues = {
    email: '',
    firstName: location.state?.plate || '',
    password: '',
    tenant_pk: tenants?.list[0]?.tenant_pk || null,
    user_group_pk: userGroups?.userGroupList[0]?.userGroupPk || null,
    docType: null,
    docNumber: '',
    phone: '',
    ocppTags: [],
    company_uuid: '',
    skip_three_ds_verification: false,
  };

  return (
    <UserCreatePageWrapper>
      <PageHeader
        className='site-page-header'
        onBack={() => history.replace('/users')}
        title={T('Creating User')}
      />
      <UserCreateForm
        initialValues={initialValues}
        tenants={tenants}
        userGroups={userGroups}
        getCompaniesData={getCompaniesData}
        companiesList={companiesList}
        chargePointsList={chargePointsList}
        availableOcppTags={mapOcppTags(availableOcppTagList)}
        type='create'
        isVehicle={isVehicle}
      />
    </UserCreatePageWrapper>
  );
};

const mapStateToProps = (state) => ({
  chargePointsList: state.chargePoints.chargePoints.chargePointList,
});

export default connect(mapStateToProps)(UserCreatePage);
